document.addEventListener('DOMContentLoaded', function() {
  var section = document.querySelector('.videoBox');
  var sectionTwo = document.querySelector('.imageBox');
  var gopUpButtonContainer = document.querySelector('#goUpButtonContainer');
  var goDownButton = document.querySelector('#goDownButton');
  var goUpButton = document.querySelector('#goUpButton');
  
var screenWidth = window.innerWidth;
var scrollingDisabled = screenWidth > 767;

  function disableScroll() {
    // Disable scrolling by setting the body's height to 100% and hiding overflow
    document.body.style.height = '100%';
    document.body.style.overflow = 'hidden';
      
  }

  function enableScroll() {
    // Enable scrolling by resetting the body's height and overflow properties
    document.body.style.height = '';
    document.body.style.overflow = '';
  }

 
  function goDown(){
     section.classList.add('out-of-screen');
    scrollingDisabled = false;


    // Remove the 'out-of-screen' class after the scroll animation is complete
    setTimeout(function() {
      section.classList.remove('out-of-screen');
      section.classList.add('noDisplay');
      sectionTwo.classList.add('noDisplay');
      enableScroll();
      goUpDownButton.blur();
    }, 500); // Adjust the timeout duration as needed
  }

  goDownButton.addEventListener('click', function() {
  goDown();
});

  document.addEventListener('keydown', function(event){
    if(event.key === "Enter"){
      goDownButton.focus();
      goDown();
    }
  })

  goUpButton.addEventListener('click', function (){

    gopUpButtonContainer.classList.add('into-screen');
    scrollingDisabled = true;
    
    setTimeout(function() {
    section.classList.remove('noDisplay');
    sectionTwo.classList.remove('noDisplay');

      disableScroll();
    }, 300);
   
  })

  window.addEventListener('scroll', function(event) {
    if (scrollingDisabled) {
      event.preventDefault();
      event.stopPropagation();
      window.scrollTo(0, 0);
    }
  });
});

